import React from "react";

import CheckboxButton from "../../style/Checkbox/CheckboxButton";
import { Flex } from "../../style/Grid";
import { Text } from "../../style/Text";

import { blogFilterArray, jobFilterArray } from "../../constants";
import {slugify} from '../../utils/slugify';

const Filter = ({ handleChange, filterData, dataType, hideCertainFilter, passRef }) => {
  let filterArray = [];
  if (dataType === "job") {
    filterArray = jobFilterArray;
  } else if (dataType === "blog") {
    filterArray = blogFilterArray;
  }

  return (
    <form ref={passRef}>
      {filterArray.map(
        filter =>
          hideCertainFilter !== filter.type && (
            <Flex
              key={filter.heading}
              flexDirection={["column", null, "column", null, null]}
            >
              <Text
                fontSize="14px"
                paddingBottom="8px"
                paddingTop="16px"
                style={{ textTransform: "uppercase" }}
              >
                {filter.heading}
              </Text>
              <Flex
                key={filter.heading}
                flexWrap={"wrap"}
                alignItem={"center"}
                justifyContent={"flex-start"}
              >
                {filter.checkboxes.map(checkbox => {
                  return (
                    <CheckboxButton key={checkbox.value}>
                      <input
                        name={filter.type}
                        type="checkbox"
                        value={checkbox.value}
                        data-filtertype={filter.heading}
                        data-filtervalue={checkbox.label}
                        onChange={handleChange}
                        checked={
                          filterData[filter.type]
                            ? filterData[filter.type].findIndex(
                                item => (checkbox.value == item || slugify(checkbox.value) == item || slugify(checkbox.label) == item)
                              ) > -1
                            : false
                        }
                      />
                      <span>{checkbox.label}</span>
                    </CheckboxButton>
                  );
                })}
              </Flex>
            </Flex>
          )
      )}
    </form>
  );
};

export default Filter;
